import AOS from 'aos' // https://github.com/michalsnik/aos - Animation On Scroll Documentation

/**
 * Initializes scroll-based animations for content widgets.
 * Applies AOS (Animate On Scroll) to React snippet components and dynamic widgets
 * below the first viewport, triggering animations once when elements scroll into view.
 * This function sets up the necessary attributes and initializes AOS with global settings.
 */

export const initialise = () => {
    const widgets = document.querySelectorAll<HTMLElement>(
        `.main-content-block > .content-widget .react-snippet-component,
        .main-content-block > .dynamic-widget > *`
    )
    const isPostResultsPage = Boolean(document.querySelector('.page-post-results'))
    const scrollOffset = isPostResultsPage ? 100 : 200
    const viewportHeight = window.innerHeight
    const scrollTop = window.scrollY

    widgets.forEach((widget: HTMLElement, index: number) => {
        const rect = widget.getBoundingClientRect()
        // Measure from the page top, including when the browser restores scrolling.
        if (rect.top + scrollTop < viewportHeight) {
            widget.removeAttribute('data-aos')
            widget.removeAttribute('data-aos-offset')
            return
        }

        widget.setAttribute('data-aos', 'fade-up')
        const isAlreadyVisible = rect.top < viewportHeight && rect.bottom > 0

        if (isAlreadyVisible || index === 0) {
            widget.setAttribute('data-aos-offset', '0')
        }
    })

    document.querySelectorAll<HTMLElement>(
        '.banner-quotes__wrapper .banner-pool-widget__container-cta[data-aos]'
    ).forEach((el) => {
        if (el.getBoundingClientRect().top + scrollTop < viewportHeight) {
            el.removeAttribute('data-aos')
            el.removeAttribute('data-aos-offset')
            return
        }

        el.setAttribute('data-aos-offset', '70')
    })

    document.body.classList.add('loaded')

    requestAnimationFrame(() => {
        AOS.init({
            duration: 300,
            easing: 'ease-in-out',
            once: true,
            offset: scrollOffset,
        })
    })
}
